import React from "react";
import { ReportBase } from "#root/components/ReportBase";
import "./styles.scss";

const AfterActionReport: React.FC = () => {
    return (
        <ReportBase 
            pageTitle="After Action Report"
            settingsButtonText="AAR Settings"
            settingsDialogTitle="AAR Settings"
            className="after-action-report-page"
        />
    );
};

export default AfterActionReport;
